const doc = [({"da":({"js":({"admin":({"activities":({"index":({"add_new_activity":"Tilføj ny aktivitet"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;